import { Box, Button, useTheme } from "@mui/material";
import React from "react";
import useDeviceType from "../../../global/Hooks/useDeviceType";

function Tabs({ setActiveFilterType, activeFilterType }) {
  const theme = useTheme().palette.mode;
  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };
  const deviceType = useDeviceType();
  return (
    <Box
      sx={{
        display: "flex",
        marginBottom: { md: 0, xs: "0.8rem" },
        width: "100%",
      }}
    >
      <Button
        onClick={() => changeActiveFilterType(1)}
        sx={{
          color: theme === "dark" ? "#FFF" : "#262D39",
          borderBottom:
            activeFilterType === 1 ? "2px solid rgba(30, 106, 253, 1)" : "",
        }}
      >
        {deviceType === "mobile" ? "قیمت کل " : "  قیمت کل  فاکتورشده "}
      </Button>
      <Button
        onClick={() => changeActiveFilterType(2)}
        sx={{
          color: theme === "dark" ? "#FFF" : "#262D39",
          borderBottom:
            activeFilterType === 2 ? "2px solid rgba(30, 106, 253, 1)" : "",
        }}
      >
        {deviceType === "mobile" ? "مساحت" : "  مساحت فاکتورشده "}
      </Button>
      <Button
        onClick={() => changeActiveFilterType(3)}
        sx={{
          color: theme === "dark" ? "#FFF" : "#262D39",
          borderBottom:
            activeFilterType === 3 ? "2px solid rgba(30, 106, 253, 1)" : "",
        }}
      >
        {deviceType === "mobile" ? "میانگین" : " میانگین قیمت فاکتورشده"}
      </Button>
    </Box>
  );
}

export default Tabs;
